import React, { useState, useEffect } from "react";
import { useSnackbar } from "react-simple-snackbar";
import { ApiService, getUserType, isPermissionExist } from "../services";
import { Add } from "@material-ui/icons";
import GButton from "../gComponents/gButton";
import GText from "../gComponents/gText";
import GEmpty from "../gComponents/gEmpty";
import GConfirmDialog from "../gComponents/gConfirmDialog";
import { useHistory } from "react-router-dom";
import CategoryForm from "../forms/productCategoryForm";
import QueryWith from "../Query";
import GListCard from "../gComponents/gListCards";
import GActions from "../gComponents/gActionsStyle";
import { StoreFilter } from "../components/storeFilterComponent";
import useDataFactory from "../useDataFactory";
import Modal from "react-modal";
import useSettings from "../useSettings";

export default function Categories(props) {
  const [openSnackbar] = useSnackbar();
  const settings = useSettings();
  const [catFormvisible, setCatFormvisible] = useState(false);
  const [isEmpty, setIsEmpty] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedCategoryData, setSelectedCategoryData] = useState({});
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  let history = useHistory();
  let params = new URLSearchParams(history.location.search);
  const [selectedStore, setSelectedStore] = useState(
    params.get("store_id") ? params.get("store_id") : ""
  );
  const {
    loading,
    data: categoriesData,
    refreshData,
    CardShimmer,
    Placeholder,
  } = useDataFactory("product/group", false, { store_id: selectedStore });

  useEffect(() => {
    var params = QueryWith(history.location, { store_id: selectedStore });
    if (params.length > 0) {
      history.push({
        pathname: "/categories",
        state: "product",
        search: params[0],
      });
    }
    if (selectedStore) {
      refreshData({ store_id: selectedStore });
    }
  }, [selectedStore, history]);

  const deleteCategory = (id) => {
    var catId = id ? id : selectedCategoryId;
    ApiService({ method: "DELETE", route: "product/categories/" + catId })
      .then((response) => {
        console.log(response.data);
        if (response.data.status_code === 1) {
          refreshData({ store_id: selectedStore });
        }
        openSnackbar(response.data.message);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleEditCtaegory = (data) => {
    setSelectedCategoryData(data);
    setIsEmpty(false);
    setSelectedCategoryId(data.parent_id);
    setCatFormvisible(true);
  };

  const handleToggleStatus = (newVal, id, ind, parentInd) => {
    console.log(newVal);
    ApiService({
      method: "PUT",
      route: "product/categories/" + id,
      body: {
        status: newVal,
      },
    })
      .then((response) => {
        console.log(response.data);
        if (response.data.status_code === 1) {
          categoriesData[parentInd].subcategories[ind].status = newVal;
        } else {
          refreshData({ store_id: selectedStore });
        }
        openSnackbar(response.data.message);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="mainInnerView" style={{ padding: "20px 20px 0" }}>
      {selectedStore &&
      (getUserType() || isPermissionExist("product_store")) ? (
        <GButton
          variant="condensed"
          children="Add"
          onClick={() => {
            setSelectedCategoryData({});
            setIsEmpty(true);
            setSelectedCategoryId("");
            setCatFormvisible(true);
          }}
          style={{
            float: "right",
          }}
        />
      ) : (
        ""
      )}
      <GText
        g1
        bold
        text={"Categories"}
        style={{ margin: "0 0 20px", fontSize: "27px" }}
      />
      <StoreFilter
        value={selectedStore}
        isStored={true}
        handleStoreChange={(value) => {
          console.log(value);
          setSelectedStore(value);
        }}
        style={{
          marginBottom: "10px",
        }}
      />

      <div className="listPaper">
        {selectedStore ? (
          <div
            style={{
              maxHeight: "calc(100vh - 270px)",
              overflowY: "auto",
              padding: "5px",
            }}
          >
            {loading ? (
              <CardShimmer />
            ) : categoriesData.length == 0 ? (
              <Placeholder />
            ) : (
              categoriesData.map((c, pi) => {
                return (
                  <React.Fragment key={c.id}>
                    <h4 style={{ margin: "10px 0" }}>
                      {c.title} ({c.subcategories.length} Subcategories)
                      {getUserType() ||
                      isPermissionExist("product_update") ||
                      isPermissionExist("product_destroy") ? (
                        <GActions
                          edit={
                            getUserType() || isPermissionExist("product_update")
                              ? true
                              : false
                          }
                          delete={
                            getUserType() ||
                            isPermissionExist("product_destroy")
                              ? true
                              : false
                          }
                          onEdit={() => {
                            setSelectedCategoryData(c);
                            setIsEmpty(false);
                            setSelectedCategoryId("");
                            setCatFormvisible(true);
                          }}
                          onDelete={() => {
                            setSelectedCategoryId(c.id);
                            setDialogOpen(true);
                          }}
                          style={{ verticalAlign: "middle" }}
                          menuStyle={{ fontWeight: "400" }}
                        />
                      ) : (
                        ""
                      )}
                      {getUserType() || isPermissionExist("product_store") ? (
                        <GButton
                          variant="linkable"
                          children="Add"
                          onClick={() => {
                            setSelectedCategoryData({});
                            setIsEmpty(true);
                            setSelectedCategoryId(c.id);
                            setCatFormvisible(true);
                          }}
                          style={{
                            float: "right",
                          }}
                        >
                          <Add />
                        </GButton>
                      ) : (
                        ""
                      )}
                    </h4>
                    <hr />

                    {c.subcategories.length === 0 ? (
                      <GEmpty></GEmpty>
                    ) : (
                      c.subcategories.map((sub, ind) => {
                        return (
                          <GListCard
                            setting="Subcategory"
                            key={ind}
                            id={sub.id}
                            title={sub.title}
                            subtitle={
                              sub.item_count +
                              (sub.item_count > 1 ? " items" : " item")
                            }
                            switch={
                              getUserType() ||
                              isPermissionExist("product_update")
                                ? true
                                : false
                            }
                            switchValue={sub.status}
                            dropdownActions={
                              getUserType() ||
                              isPermissionExist("product_update") ||
                              isPermissionExist("product_destroy")
                                ? true
                                : false
                            }
                            edit={
                              getUserType() ||
                              isPermissionExist("product_update")
                                ? true
                                : false
                            }
                            delete={
                              getUserType() ||
                              isPermissionExist("product_destroy")
                                ? true
                                : false
                            }
                            onEdit={handleEditCtaegory}
                            onDelete={(id) => {
                              //setSelectedCategoryId(id);
                              deleteCategory(id);
                            }}
                            data={sub}
                            onSwitchToggle={(val, id) =>
                              handleToggleStatus(val, id, ind, pi)
                            }
                            style={{ width: "23%" }}
                            titleStyle={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              height: "22px",
                            }}
                          ></GListCard>
                        );
                      })
                    )}
                  </React.Fragment>
                );
              })
            )}
          </div>
        ) : (
          <GEmpty
            title="Categories"
            subtitle="Please choose the store to fetch the categories list"
          />
        )}
      </div>

      {dialogOpen === true && (
        <GConfirmDialog
          open={dialogOpen}
          title="Delete Category"
          text="Are you sure you want to delete this category?"
          handleClose={() => setDialogOpen(false)}
          onConfirmClose={() => {
            setDialogOpen(false);
            deleteCategory();
          }}
        ></GConfirmDialog>
      )}

      <Modal
        isOpen={catFormvisible}
        className="modal modalRight"
        overlayClassName="modal-overlay"
        onRequestClose={() => setCatFormvisible(false)}
        style={{
          content: {
            width: "400px",
          },
        }}
        contentLabel="Category Form Modal"
      >
        <CategoryForm
          storeId={selectedStore}
          categoryId={selectedCategoryId}
          catFormvisible={catFormvisible}
          setCatFormvisible={setCatFormvisible}
          data={selectedCategoryData}
          isEmpty={isEmpty}
          settings={settings}
          onSubmit={() => refreshData({ store_id: selectedStore })}
          onLocalizationRemove={(ind) => {
            if (selectedCategoryId) {
              let findInd = categoriesData.findIndex(
                (nId) => nId?.id == selectedCategoryId
              );
              if (findInd > -1) {
                let findSubCatInd = categoriesData[
                  findInd
                ].subcategories.findIndex(
                  (s) => s?.id == selectedCategoryData.id
                );

                categoriesData[findInd].subcategories[
                  findSubCatInd
                ].localizations.splice(ind, 1);
              }
            } else {
              let findInd = categoriesData.findIndex(
                (nId) => nId?.id == selectedCategoryData.id
              );

              if (findInd > -1) {
                categoriesData[findInd].localizations.splice(ind, 1);
              }
            }
          }}
          onLocalizationUpdate={(ind, data) => {
            if (selectedCategoryId) {
              let findInd = categoriesData.findIndex(
                (nId) => nId?.id == selectedCategoryId
              );
              if (findInd > -1) {
                let findSubCatInd = categoriesData[
                  findInd
                ].subcategories.findIndex(
                  (s) => s?.id == selectedCategoryData.id
                );

                categoriesData[findInd].subcategories[
                  findSubCatInd
                ].localizations[ind] = data;
              }
            } else {
              let findInd = categoriesData.findIndex(
                (nId) => nId?.id == selectedCategoryData.id
              );

              if (findInd > -1) {
                categoriesData[findInd].localizations[ind] = data;
              }
            }
          }}
        />
      </Modal>
    </div>
  );
}
